// extracted by mini-css-extract-plugin
export default {"rect":"AudioIcon_rect__8p8Rx","path":"AudioIcon_path__Bquiz"};